import * as PIXI from "pixi.js";
import Layers from "../../../../src/layers/Layers";
import { EnumEventBus, EventBus } from "../managers/EventBus";
import { Coord } from "../../../../src/types/Interface";
import { PURPLE_COLORS } from "../types/Config";

export default class TangentRatioButton extends PIXI.Graphics {
  private Layers = Layers.getInstance();
  private EventBus = EventBus;

  private index: number
  private fillColor: number = PURPLE_COLORS[0];
  private strokeColor: number = PURPLE_COLORS[1];


  constructor(index: number) {
    super();
    this.index = index;

    this.addInteractivity();
    this.addToLayer();
  }
  addToLayer = () => this.Layers.UI.addChild(this);

  addInteractivity() {
    const setSltdTPIndex = () => this.EventBus.emit(EnumEventBus.setSltdTPIndex, this.index);
    this.interactive = true;
    this.cursor = "pointer";

    this.on("mousedown", () => setSltdTPIndex());
    this.on("touchstart", () => setSltdTPIndex());
  }
  draw(coord: Coord, selected: boolean) {
    const r = 14;
    const strokeW = 3;
    this
      .clear()
      .circle(coord.x, coord.y, r + (selected ? strokeW / 2 : 0));

    selected
      ? this.fill(this.fillColor)
      : this
        .fill(0xFFFFFF)
        .stroke({ color: this.strokeColor, width: strokeW });
  }
}